import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IProjectDetails } from '../shared/models/project-details';
import { ProjectService } from '../shared/services/project.service';

@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrl: './project-details.component.scss',
  standalone: false,
})
export class ProjectDetailsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  projectDetails: IProjectDetails | null = null;
  selectedTab: string = '';
  salesforceId: string | null = null;
  loading: boolean = true;
  loadError: boolean = false; // loading error and default false.

  constructor(
    private _projectService: ProjectService,
    private _activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this._activatedRoute.paramMap.subscribe((paramMap) => {
        const projectId = paramMap.get('id');
        if (projectId) {
          this.loadProjectDetails(Number(projectId));
        }
      }),
    );
  }

  loadProjectDetails(projectId: number) {
    this.loading = true;
    this.projectDetails = null;
    this.salesforceId = null;
    this.loadError = false; // add a flag for error handling

    const projectDetailsSubscription = this._projectService
      .getProjectDetails(projectId)
      .subscribe({
        next: (response) => {
          if (response.success && response.content) {
            this.projectDetails = response.content;
            this.salesforceId = this.projectDetails.salesforceId || null;
          } else {
            this.loadError = true; // mark error if response not successful
          }
          this.loading = false;
        },
        error: (_) => {
          this.loading = false;
          this.loadError = true; // mark error if API fails
        },
      });

    this.subscriptions.add(projectDetailsSubscription);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  onTabChange(tabId: string) {
    this.selectedTab = tabId;
  }
}
